<template>
  <div class="meeting-bill-detail">
    <el-container>
      <el-header style="background-color: white; padding-bottom: 60px">
        <el-button
          type="text"
          @click="showPolicy"
          style="float: right; position: relative; z-index: 100"
          >查看政策说明</el-button
        >
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="first">
            <el-form
              :model="detail"
              label-width="100px"
              :inline="true"
              style="text-align: left"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提报部门：">
                    <el-input :value="detail.deptName" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="汇报人：">
                    <el-input
                      :value="detail.reportUserName"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目分类：">
                    <el-input
                      :value="detail.projectTypeValue"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提报日期：">
                    <el-input :value="detail.createTime" readonly></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                  <el-form-item label="上会状态：">
                    <el-input :value="detail.isSubmitted" readonly></el-input>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="会议议题：">
                    <el-input :value="detail.title" readonly></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="主要内容：">
                    <el-input
                      type="textarea"
                      :value="detail.content"
                      :rows="8"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="出席人：">
                    <div class="el-input tag-wrapper">
                      <el-tag
                        v-for="(tag, index) in detail.joinWorkList"
                        :key="index"
                        style="margin-right: 5px"
                        >{{ tag.displayName || tag.name }}</el-tag
                      >
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="参会部门：">
                    <div class="el-input tag-wrapper">
                      <el-tag
                        v-for="(tag, index) in detail.checkWorkList"
                        :key="index"
                        style="margin-right: 5px"
                        >{{ tag.displayName || tag.name }}</el-tag
                      >
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="是否上会：">
                    <!-- <el-input
                      :value="detail.approveStatus == 5 ? '已上会' : '未上会'"
                      readonly
                    ></el-input> -->
                    <el-input :value="detail.isSubmitted" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上会说明：">
                    <el-input
                      type="textarea"
                      :value="detail.submitDesc"
                      :rows="3"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row v-if="canApprove">
                <el-col :span="24">
                  <el-form-item label="审批意见：">
                    <el-input
                      type="textarea"
                      :rows="5"
                      placeholder="-请输入-"
                      maxlength="100"
                      show-word-limit
                      v-model="approveFormData.opinion"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件" name="second">
            <upLoadFileDialog
            :itemVOs="detail.declarationItemsVOs"
            :itemId="id"
            :approveStatus="detail.approveStatus"
            :type="approveType"
            :isUploadAllowed="detail.isUploadAllowed"
            @saveUpdateFile="getDetail()"
          ></upLoadFileDialog>
          </el-tab-pane>
          <el-tab-pane
            v-if="isPaymentApply"
            label="付款申请"
            name="four"
            style="min-height: 500px"
          >
            <el-form label-width="120px">
              <el-form-item label="项目部">
                <el-input :value="paymentApplyDeptName" readonly></el-input>
              </el-form-item>
              <el-form-item label="项目名称">
                <el-input :value="paymentApplyProjectName" readonly></el-input>
              </el-form-item>
            </el-form>
            <div class="table-header-flex" v-if="paymentApplyDetailData">
              <span>所属年度:{{ paymentApplyDetailData.belongYear }}</span>
              <span>上报日期:{{ paymentApplyDetailData.createTime }}</span>
              <span>单位:元</span>
            </div>
            <div class="table-wrapper">
              <div v-if="paymentApplyDetailData" class="custom-table-header">
                <span class="thead-span"
                  >合同金额：{{
                    formatNumber(paymentApplyDetailData.contractAmount)
                  }}元</span
                >
                <span class="thead-span"
                  >工程收入：{{
                    formatNumber(paymentApplyDetailData.finishPriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >上报计量：{{
                    formatNumber(paymentApplyDetailData.calculatePriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >已收计量金额：{{
                    formatNumber(paymentApplyDetailData.receiptPriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >收集团拨款金额：{{
                    formatNumber(paymentApplyDetailData.groupAmount)
                  }}元</span
                >
              </div>
              <div v-if="paymentApplyDetailTable">
                <el-table
                  :data="paymentApplyDetailTable"
                  border
                  width="100%"
                  :span-method="arraySpanMethod"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="columnTitle"
                    label="项目"
                    width="150"
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="partyB"
                    label="合作单位"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="serialNumber"
                    label="合同编号"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <!-- <div
                        slot="content"
                        v-if="Array.isArray(scope.row.serialNumber)"
                      >
                        <p
                          v-for="item in scope.row.serialNumber"
                          :key="item"
                          style="margin-bottom: 0; min-width: 200px"
                        >
                          {{ item }}
                        </p>
                      </div>
                      <div v-else>
                        <p style="margin-bottom: 0; min-width: 200px">
                          {{ scope.row.serialNumber }}
                        </p>
                      </div> -->

                      <div class="number-list-wrapper">
                        {{ formatSerialNumber(scope.row.serialNumber) }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="contractContent"
                    label="合同内容"
                    width="200"
                  ></el-table-column>
                  <el-table-column label="税后合价" width="200">
                    <template slot-scope="scope">
                      <div>{{ formatNumber(scope.row.settleAmount) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="累计已付款" width="200">
                    <template slot-scope="scope">
                      <div>{{ formatNumber(scope.row.alreadyPay) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="尚欠款" width="200">
                    <template slot-scope="scope">
                      <div>{{ formatNumber(scope.row.debtAmount) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="已付款比例" width="200">
                    <template slot-scope="scope">
                      <div>{{ formatPercent(scope.row.alreadyPayPct) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="本次拟付款" width="200">
                    <template slot-scope="scope">
                      <div>{{ formatNumber(scope.row.thisPay) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="再付款比例" width="200">
                    <template slot-scope="scope">
                      <div>{{ formatPercent(scope.row.thisPayPct) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="备注"
                    width="200"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="fromApprove ? '审批信息' : '审批流程'"
            name="third"
          >
            <div style="display: none">fromApprove:{{ fromApprove }}</div>
            <!-- 从审批台过来，展示的是审批。从详情过来，展示的是当前走的审批流程 -->
            <!-- 只有能审批时，才能从审批台过来，否则过不来。所以只要从审批台过来就展示审批信息 -->
            <div v-if="!fromApprove||!canApprove">
              <approveLine
              :itemId="id"
              :approveType="approveType"
            ></approveLine>
            </div>
            <div v-else style="width: 800px">
              <approveItem
              :itemId="id"
              :approveType="approveType"
              @finishApprove="closePage"
            >
            </approveItem>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="会议提报单"
            name="seventeen"
            style="text-align: left"
            class="firstTab"
          >
            <MeetingOrder
              :itemId="id"
              :approveType="approveType"
            ></MeetingOrder>
          </el-tab-pane>
        </el-tabs>
      </el-header>
     
        <div class="bottomBtn">
          <!-- <el-button type="primary" @click="backApprove" v-if="canCallback"
            >撤回</el-button
          > -->
          <!-- <el-button
                  type="primary"
                  @click="rejectApprove"
                  v-if="canApprove"
                  >驳回</el-button
                > -->
          <!-- <el-button
                  type="primary"
                  @click="agreeApprove"
                  v-if="canApprove"
                  >通过</el-button
                > -->
                 <!-- <el-button type="primary" @click="doSubmitApprove" v-if="fromApprove&&activeName=='third'"
                    >审批</el-button
                  > -->
          <el-button type="info" v-if="isZongheban == 1&&activeName!='seventeen'&&!isPaymentApply" @click="upMeetingSetFun">上会设置</el-button>
          <el-button type="info" @click="closePage">关闭</el-button>
          
        </div>
    </el-container>
    <el-dialog title="政策说明" :visible.sync="policyVisible">
      <div v-html="policyStr"></div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="policyVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
     <!--上会设置-->
     <upMeetingSet
        :visible="upMeetingSetVisible"
        :id='[detail]'
        @handleChange="handleChange"
        v-if="upMeetingSetVisible"
      >
      </upMeetingSet>
  </div>
</template>
<script>
import {
  exportExcelService2, //导出
  getTempUrlService //下载附件
} from "@/services/commonService";
import {
  earningCostqueryDeptListApi,
  earningCostqueryProjectListAPi,
} from "@/services/financeService";
import {previewFile} from "@/utils/index.js"
import upMeetingSet from "./components/upMeetingSet";

import {
  getDeclarationDetail,
  queryApproveProcess,
} from "@/services/declarationServices";
import Constants from "@/utils/consts";
import { formatMoney, formatPercent } from "../../finance/utils";
import { getRuleDetailService } from "@/services/sysSettingService";
import { goBackApprove } from "@/page/approveComponents/approve";
import MeetingOrder from "./components/MeetingOrder"; //会议提报单
import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import approveItem from "@/page/approveComponents/ApproveItem"; //审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件

export default {
  name: "MeetingBillDetail",
  components: {
    MeetingOrder,
    upMeetingSet,
    approveLine, //审批历史流程
    approveItem, //审批
    upLoadFileDialog,
  },
  data() {
    return {
      isZongheban: sessionStorage.getItem('isZongheban'),
      approveType: "DECLARATION",
      fromApprove: false, // 从审批台过来的吗？从审批台过来，是审批。从详情过来，是审批的流程信息展示
      currentApplyDate: "",
      policyVisible: false,
      upMeetingSetVisible: false,//上会设置弹窗可见性
      policyStr: "",
      id: null, // 提报单的id
      activeName: "first",
      approveFormData: {
        status: 3,
        opinion: "",
        sort: null,
      },
      canApprove: false,
      detail: {
        // 详情的回包结构
        applyUserId: null,
        applyUserName: "",
        approveStatus: null,
        approveStatusName: "",
        checkWorkJson: "", // 参会部门
        checkWorkList: [],
        content: "", // 主要内容
        createTime: "",
        declarationItemsVOs: [],
        deptId: null, // 提报部门id
        deptName: "", // 提报部门
        id: null,
        joinWorkJson: "", // 出席人
        joinWorkList: [],
        projectType: "", // 项目分类键
        projectTypeValue: "", // 项目分类的名

        reportUserId: null, // 汇报人id
        reportUserName: "", // 汇报人
        title: "", // 会议议题
        updateTime: "",
      },
      fileTableProps: [
        { prop: "name", label: "文件名称", width: "" },
        { prop: "uploadUserName", label: "上传者", width: "160px" },
        { prop: "updateTime", label: "上传时间", width: "150px" },
      ],
      approveTableProps: [
        { prop: "approveUserName", label: "员工名称" },
        { prop: "jobName", label: "岗位名称" },
        { prop: "opinion", label: "相关意见" },
        { prop: "statusName", label: "当前状态" },
      ],
      paymentApplyDeptId: undefined,
      paymentApplyProjectId: undefined,
      paymentApplyDetailData: undefined,
      paymentApplyDetailTable: [],
      paymentApplyDeptName: undefined,
      paymentApplyProjectName: undefined,
      isPaymentApply: false,
      approveFlag: "",
    };
  },

  methods: {
    previewFile,
    formatSerialNumber(serialNumber) {
      if (!serialNumber) {
        return "";
      }
      if (Array.isArray(serialNumber)) {
        return serialNumber.join("、");
      }
      return serialNumber;
    },
    // 表格合并计算方法
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 1) {
        const {
          serviceCostAnalysis = [],
          materialCostAnalysis = [],
          machineCostAnalysis = [],
          otherDirectCostAnalysis = [],
        } = this.paymentApplyDetailData;
        if (row.columnTitle == "劳务费") {
          let index = serviceCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: serviceCostAnalysis.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (row.columnTitle == "材料费") {
          let index = materialCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: materialCostAnalysis.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (row.columnTitle == "机械费") {
          let index = machineCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: machineCostAnalysis.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (row.columnTitle == "其他直接费") {
          let index = otherDirectCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: otherDirectCostAnalysis.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
     //上会设置
     upMeetingSetFun() {
      // let target = this.selectItems[0];
      // if(this.detail.isSubmitted=='已上会'){
      //   this.$alert('已上会会议提报不允许修改上会状态', "提示");
      // }else
      this.upMeetingSetVisible = true;
    },
    //关闭上会设置弹窗
    handleChange(val){
      if(val)
      this.getDetail()
      this.upMeetingSetVisible = false;
    },
    showPolicy() {
      this.policyVisible = true;
    },
    initPolicy() {
      let businessType = "0003";
      getRuleDetailService(businessType)
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.policyStr = res.data.typeExplain;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    closePage() {
      if (this.isPaymentApply) {
        console.log("--付款申请列表");
        if (this.approveFlag) {
          goBackApprove(this.approveFlag, "paymentApplyDetailView");
        } else {
          this.bus.$emit("tabClose", "paymentApplyDetailView");
          this.bus.$emit("navMenuChange", {
            routeId: "paymentApplyList",
          });
        }
      } else {
        console.log("--提报单列表");
        if (this.approveFlag) {
          goBackApprove(this.approveFlag, "meetingBillDetailView");
        } else {
          this.bus.$emit("tabClose", "meetingBillDetailView");
          this.bus.$emit("navMenuChange", {
            routeId: "meetingList",
          });
        }
      }
    },
    getApproveData() {
      queryApproveProcess({
        id: this.id,
        type: "DECLARATION",
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let approveData = res.data || {};
            let myId = sessionStorage.getItem("currentUserId");
            if (approveData.approveUserId == myId && approveData.status == 2) {
              this.canApprove = true;
              // 确定需要自己审批时才带上这个sort
              this.approveFormData.sort = approveData.sort;
            } else {
              this.canApprove = false;
            }
          }
        })
        .catch((error) => {
          console.log("---获取审批流报错", error);
          this.canApprove = false;
        })
        .finally(() => {
          console.log("this.canApprove", this.canApprove);
        });
    },

    //-----------------------------------
    onActive(menucode) {
      let params = this.tabRouteParam || {};
      if (params.id) {
        this.id = params.id;
      }
      this.isPaymentApply=params.paymentApply||false
      this.approveFlag = params.approveFlag;
      this.activeName = "first";
      console.log("meeting bill detail. id:", this.id, typeof this.id);
      console.log("approveFlag", this.approveFlag);
      //2022-09-22 09:56:49
      // 'currentApprove' 审批项目 'waitApproveDetail' 待审批列表进审批详情 'historyApproveDetail' 审批历史列表进审批详情
      if (params.approveFlag == "currentApprove") {
        // 从待审批列表来
        this.fromApprove = true;
      } else {
        this.fromApprove = false;
      }

      this.getDetail();
      this.initPolicy();
    },
    getDetail() {
      getDeclarationDetail({
        id: this.id,
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let data = res.data;
            try {
              if (data.checkWorkJson) {
                data.checkWorkList = JSON.parse(data.checkWorkJson);
              }
              if (data.joinWorkJson) {
                data.joinWorkList = JSON.parse(data.joinWorkJson);
              }
              this.detail = data;
              console.log("提报单详情", this.detail);
              this.paymentApplyDeptId = this.detail.projectDeptId;
              this.paymentApplyProjectId = this.detail.projectId;
              // this.isPaymentApply = this.detail.projectType.indexOf("pay") > -1;
              this.getPaymentApplyDeptName();
              this.getPaymentApplyProjectName();
              let { declarationPayRequestVO } = data;
              if (declarationPayRequestVO) {
                this.$set(
                  this,
                  "paymentApplyDetailData",
                  declarationPayRequestVO
                );
                const {
                  serviceCostAnalysis = [],
                  materialCostAnalysis = [],
                  machineCostAnalysis = [],
                  otherDirectCostAnalysis = [],
                } = declarationPayRequestVO;
                serviceCostAnalysis.forEach((item) => {
                  item.columnTitle = "劳务费";
                });
                materialCostAnalysis.forEach((item) => {
                  item.columnTitle = "材料费";
                });
                machineCostAnalysis.forEach((item) => {
                  item.columnTitle = "机械费";
                });
                otherDirectCostAnalysis.forEach((item) => {
                  item.columnTitle = "其他直接费";
                });
                let tableData = []
                  .concat(serviceCostAnalysis)
                  .concat(materialCostAnalysis)
                  .concat(machineCostAnalysis)
                  .concat(otherDirectCostAnalysis);

                this.paymentApplyDetailTable = tableData;
              }
            } catch (error) {
              console.log(error);
            }
          } else if (res.code >= Constants.Code_Err) {
            this.$alert(res.msg, "提示");
          } else {
            this.$alert(Constants.Err_Msg, "提示");
          }
        })
        .then(() => {
          this.getApproveData();
        })
        .catch((error) => {
          if (error instanceof Error) {
            this.$message.error(error.message);
          } else if (error instanceof String) {
            this.$message.error(error);
          } else {
            this.$message.error(Constants.Err_Msg);
          }
        });
    },
    getPaymentApplyDeptName() {
      if (this.paymentApplyDeptId) {
        let targetid = this.paymentApplyDeptId;
        earningCostqueryDeptListApi()
          .then((res) => {
            let data = res.data || [];
            console.log("-- 找到的项目部", data);
            let target = data.find((item) => item.deptId == targetid);
            if (target) {
              this.paymentApplyDeptName = target.deptName;
            }
          })
          .catch(() => {});
      }
    },
    getPaymentApplyProjectName() {
      if (this.paymentApplyDeptId && this.paymentApplyProjectId) {
        let targetid = this.paymentApplyProjectId;
        earningCostqueryProjectListAPi({
          deptId: this.paymentApplyDeptId,
        })
          .then((res) => {
            let data = res.data || [];
            console.log("-- 找到的项目", data);

            let target = data.find((item) => item.projectId == targetid);
            if (target) {
              this.paymentApplyProjectName = target.projectName;
            }
          })
          .catch(() => {});
      }
    },
   
    downloadFile(index, row) {
      let reqParam = {
        filePath: row.resource,
        fileName:row.name,
      };
      getTempUrlService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            //下载附件
            console.log(res.data)
            exportExcelService2(res.data.renameUrl).then((res1) => {
              this.$alert("下载成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },

    formatNumber: formatMoney,
    formatPercent: formatPercent,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.meeting-bill-detail {
  background: #fff;
  height: 100%;
  overflow: auto;
  .bottomBtn {
    position: fixed;
    left: 300px;
    width: 900px;
    height: 60px;
    line-height: 60px;
    // position: absolute;
    // // left: 260px;
    // height: 40px;
    // line-height: 40px;
    bottom: 10px;
    // width: 70%;
    background: #fff;
    // text-align: left;
    padding-left: 260px;
    z-index: 90;
  }
}

.el-tab-pane {
  margin-top: 20px;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

/deep/ .el-form-item__content {
  display: flex;

  .el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
    height: fit-content;
  }
}
/deep/.ApproveItem .bottomBtn {
  bottom: 22px;
  z-index: 100;
  left: 444px;
}

.tag-wrapper {
  border: 1px solid #dcdfe6;
  padding: 0 5px;
}

// /deep/ .el-tab-pane {
//   min-height: 500px !important;
// }

.approve-btns {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.table-header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.table-wrapper {
  position: relative;

  .custom-table-header {
    position: relative;
    width: 100%;
    padding: 20px 10px;
    background: #edf8fa;
    border-bottom: 1px solid #ebeef5;

    .thead-span {
      margin-right: 20px;
    }
  }
}
</style>
